import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HorribleHeroesReelController} from "../reel/HorribleHeroesReelController";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {HorribleHerosXSymbol} from "../symbols/HorribleHerosXSymbol";
import {SoundManager} from "../resource/sound/SoundManager";
import {HorribleHeroesSoundConfig} from "../HorribleHeroesSoundConfig";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";

export class MysteryFeatureExpansion implements GameRoundPresentation {
    public IsXWayExpanded: boolean[];
    public gameAreaSizeAfter: number[] = [];
    private maintlduration: number = 0;
    private isAborted: boolean = false;
    private _XSymbolSize: number[];
    private expandedSym = "";
    private isFeatureStarted: boolean = false;
    private XSymbolPositions: number[] = [];
    private _isXWaysInfected: boolean = false;
    private gameData: HorribleHeroesParsedGameData;
    private _isMayhemMode: boolean = false;

    // #441
    private _xWaysRevealSoundPlayed: boolean = false;

    constructor() {
    }

    /**
     * @inheritDoc getAnimation
     * @HorribleHeroesParsedGameData
     *
     */
    public getAnimation(data: HorribleHeroesParsedGameData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        const Xwaypos: number = 0.1;
        let timelineEndPos: number = 0.5;

        this.maintlduration = timelineEndPos;

        // #441
        this._xWaysRevealSoundPlayed = false;

        if (data.isXWayExpanded.filter(Boolean).length > 0) {
            // #543
            tl.delay(HorribleHeroesGameConfig.instance.FS_TRIGGER_DELAY);

            tl.add(() => {
                for (let index: number = 0; index < this.XSymbolPositions.length; index++) {
                    if (this.XSymbolPositions[index] > -1) {
                        if (!this.isAborted) {
                            this.isFeatureStarted = true;
                            this.convertXSymbolAnimation(index, this.XSymbolPositions[index]);
                        }
                    }
                }
            }, Xwaypos);
            tl.add(() => {
            }, timelineEndPos);
        }

        return tl;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: HorribleHeroesParsedGameData): void {
        this.IsXWayExpanded = data.isXWayExpanded;
        this.gameAreaSizeAfter = data.getGameAreaSizeAfter;
        this._XSymbolSize = data.mysterySymbolSizes;
        this.expandedSym = data.getExpandedSymbol;
        this.XSymbolPositions = data.XSymbolPositions;
        this.isFeatureStarted = false;
        this.isAborted = false;
        this._isXWaysInfected = data.XWaysInfectiousTriggered;
        this.gameData = data;
        this._isMayhemMode = data.isSuperActivatedSpin && !data.superFSTriggered;
    }

    public abort(isActive: boolean, data: HorribleHeroesParsedGameData): Timeline | null {
        let tl: TimelineLite = new TimelineLite();
        this.isAborted = true;
        if (!this.isFeatureStarted) {
            this.IsXWayExpanded.forEach((onReel, reelId) => {
                if (onReel) {
                    this.convertXSymbolAnimation(reelId, this.XSymbolPositions[reelId])
                }
            });
        }
        tl.add(() => {
            HorribleHeroesGameModuleConfig.reelBackGroundView.updateTotalXWays();
        }, 0.1);
        tl.add(() => {
        }, this.maintlduration);
        return tl;
    }

    /*convertXSymbolAnimation from X2/X3 to revealeadSym
    * converting from X to other symbols
    * */
    private convertXSymbolAnimation(reelId: number, symId: number, isAbort?: boolean): TimelineLite {
        let convertPos: number = 0.12;
        const isNoWin: boolean = !this.gameData.isTotalWin;
        const reelTimeline: TimelineLite = new TimelineLite();
        if (symId == -1) {
            return reelTimeline;
        }
        const mysterySymbol: StateReelSymbol | null = Reels.getSymbol(reelId, symId);
        if (!mysterySymbol) {
            debugger;
            throw new Error(`ReelExpansionController.onReelSpinStopped(): Cannot find symbol at reelId = ${reelId}, symbolId = ${this.XSymbolPositions[reelId]}.`);
        }
        if (this.isAborted) {
            convertPos = 0.12;
        }
        reelTimeline.add(() => {
            const mysteryRSize: number = 4 + this._XSymbolSize[reelId] - 1;
            const mSize: number = this._XSymbolSize[reelId];
            HorribleHeroesGameModuleConfig.symbolWinAnimation.resetThunder();
            if (Reels.getSymbol(reelId, symId)!.symName.indexOf("X") !== -1) {
                (Reels.getSymbol(reelId, symId) as HorribleHerosXSymbol)!.hideSaberAnimation(this.isAborted);
            }
            const revealAnim: TimelineLite = HorribleHeroesGameModuleConfig.symbolWinAnimation.revealAnimation(reelId, symId, mSize, mysteryRSize, this._isXWaysInfected, 0, this._isMayhemMode);
            if (isNoWin) {
                revealAnim.play();
                revealAnim.timeScale(2);
            } else {
                revealAnim.play();
            }
            //#226
            //#331
        }, 0);
        reelTimeline.add(() => {
            (<HorribleHeroesReelController>Reels.getReel(reelId)).conversionXwaySym(this.expandedSym, this._XSymbolSize[reelId], symId, this.gameAreaSizeAfter[reelId]);
            HorribleHeroesGameModuleConfig.symbolWinAnimation.resetThunder();

            // #441
            if (this.IsXWayExpanded[reelId]) {
                if (!this._xWaysRevealSoundPlayed) {
                    this._xWaysRevealSoundPlayed = true;
                    SoundManager.playXWaysReveal();

                    SoundManager.stopSound(HorribleHeroesSoundConfig.instance.X_WAYS_ELECTRICITY);
                }
            }
        }, convertPos);
        //to reveal symbol, after animation has completed
        return reelTimeline;
    }
}
